import { anomaliesHandledIcon, anomaliesHSCodeOrDescriptionIcon, anomalyValueIcon, noSentAnomaliesIcon, notSentIcon } from '@assets';
import { Box } from '@mantine/core';

import { DeclarationGeneralInfo, DeclarationGoods } from '@e-origin/shared';
import { IconBox } from '@components';

interface GoodsItemStatusIndicatorProps {
  generalInfo: DeclarationGeneralInfo;
  goodDetails: DeclarationGoods;
}

export const GoodsItemStatusIndicator: React.FC<GoodsItemStatusIndicatorProps> = (props) => {
  const { generalInfo, goodDetails } = props;

  const hasAnomaliesDetectedDescription = goodDetails.anomaliesDetected && goodDetails.evalMethodDescription?.webMatchingDescription === false;

  const hasAnomaliesDetectedHSCode = goodDetails.anomaliesDetected && goodDetails.evalMethodAiHsCode?.hsCodeOk === false;

  const hasAnomaliesDetectedValue = goodDetails.anomaliesDetected && goodDetails.invoicedRateOk === false;

  const hasAnomaliesDetectedAllHandledByUser =
    goodDetails.anomaliesDetected &&
    goodDetails.evalMethodAiHsCode?.hsCodeOk &&
    goodDetails.evalMethodDescription?.webMatchingDescription &&
    goodDetails.invoicedRateOk;

  const hasNoAnomaliesDetected = generalInfo?.complianceCheck && goodDetails?.anomaliesDetected === false;

  const hasNoRiskAnalysisDone = generalInfo?.complianceCheck === false;

  return (
    <Box display={'flex'}>
      {hasAnomaliesDetectedValue && <IconBox icon={anomalyValueIcon} alt={'anomalies-detected-value'} />}
      {(hasAnomaliesDetectedDescription || hasAnomaliesDetectedHSCode) && (
        <IconBox icon={anomaliesHSCodeOrDescriptionIcon} alt={'anomalies-detected-HS-code-or-description'} />
      )}
      {hasNoAnomaliesDetected && <IconBox icon={noSentAnomaliesIcon} alt={'no-anomalies-detected'} />}
      {hasAnomaliesDetectedAllHandledByUser && <IconBox icon={anomaliesHandledIcon} alt={'anomalies-detected-all-handled-by-user'} />}
      {hasNoRiskAnalysisDone && <IconBox icon={notSentIcon} alt={'no-risk-analysis-done'} />}
    </Box>
  );
};
